import React from "react";
import OrderHeadSectionComponent from "../../../components/headSection/components/OrderHeadSectionComponent";
import ProfilePath from "./ProfilePath";
import {Button} from "@mui/material";
import {useDispatch} from "react-redux";
import {updatePassword} from "../../../actions/users";
import {useNavigate} from "react-router-dom";
import ContactSectionComponent from "../../../pages/main/sections/contactSection/ContactSectionComponent";

const ProfileSectionChangePassword = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [password, setPassword] = React.useState<string>('');
    const [confirmPassword, setConfirmPassword] = React.useState<string>('');

    const [togglePassword, setTogglePassword] = React.useState<boolean>(false);
    const [toggleConfirmPassword, setToggleConfirmPassword] = React.useState<boolean>(false);

    const handleTogglePassword = () => {
        setTogglePassword(!togglePassword);
    }

    const handleToggleConfirmPassword = () => {
        setToggleConfirmPassword(!toggleConfirmPassword);
    }

    const handleButtonFormChangePasswordSubmit = async () => {
        try {
            const existUser = JSON.parse(sessionStorage.getItem('user') as any);
            if (existUser) {

                const response = await updatePassword(dispatch, existUser.password, password);

                if (response) {
                    alert("Password successfully updated");
                    navigate('/profile');
                }
                else {
                    alert("Password is incorrect");
                }

                /*const response = await fetch(`http://localhost:5000/api/auth/update/${existUser._id}`, {
                    method: "PUT",
                    headers: {"Content-Type": "application/json"},
                    body: JSON.stringify({
                        password
                    })
                });
                const content = await response.json();
                console.log("update content: ", content);
                if (content) {
                    alert("successfully update");
                }
            */
            }
        } catch (e) {
            console.log("error e: ", e);
        }
    }

    return (
        <div className="profileSectionChangePassword__container">
            <OrderHeadSectionComponent />
            <ProfilePath
                path={['Profile', 'Change password']}
                component="Profile"
            />
            <div className="profileSectionChangePassword__container-content">
                <form className="profileSectionChangePassword__container-content_form">
                    <div className="profileSectionDataForm__container_content_form_input_wrap password">
                        <label htmlFor="password">Password</label>
                        <div className="profileSectionDataForm__container_content_form_input_wrap_password">
                            <input
                                type={`${togglePassword ? 'text' : 'password'}`}
                                id="password"
                                name="password"
                                required
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                            <div className="profileSectionDataForm__container_content_form_input_wrap_password_toggle">
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/eye-${togglePassword ? 'open' : 'close'}.svg`}
                                    alt="eye"
                                    onClick={handleTogglePassword}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="profileSectionDataForm__container_content_form_input_wrap confirm-password">
                        <label htmlFor="confirm-password">Confirm Password</label>
                        <div className="profileSectionDataForm__container_content_form_input_wrap_password">
                            <input
                                type={`${toggleConfirmPassword ? 'text' : 'password'}`}
                                id="confirm-password"
                                name="confirm-password"
                                required
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                            />
                            <div className="profileSectionDataForm__container_content_form_input_wrap_password_toggle">
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/eye-${toggleConfirmPassword ? 'open' : 'close'}.svg`}
                                    alt="eye"
                                    onClick={handleToggleConfirmPassword}
                                />
                            </div>
                        </div>
                    </div>
                </form>

                <div className="profileSectionDataForm__container-button-btn_wrap">
                    <Button
                        className="profileSectionDataForm__container-button-btn save"
                        variant="contained"
                        onClick={handleButtonFormChangePasswordSubmit}
                        disabled={!(password !== '' && password === confirmPassword)}
                    >
                            <span>
                                save
                            </span>
                    </Button>
                </div>
            </div>
            <ContactSectionComponent />
        </div>
    )
}

export default ProfileSectionChangePassword;